import Config from "./../../config";
import AppStore from './../store';

class RTFetcher {
    constructor(host) {
        this.host = host;
        if (this.host[this.host.length - 1] === '/') {
            this.host = this.host.substr(0, this.host.length - 1);
        }
    }

    makeRequest(url, method = 'GET', data = null, headers, refresh = false) {
        return new Promise((resolve, reject) => {
            let _headers = {
                'Content-Type': 'application/json'
            };

            if (AppStore.get(`${Config.AUTH_PREFIX}access`)) {
                _headers[Config.AUTH_HEADER || 'Authorization'] = AppStore.get(`${Config.AUTH_PREFIX}access`);
            }

            if (refresh === true && AppStore.get(`${Config.AUTH_PREFIX}refresh`)) {
                _headers[Config.AUTH_HEADER || 'Authorization'] = AppStore.get(`${Config.AUTH_PREFIX}refresh`);
            }

            if (headers) {
                if (headers['Content-Type']){
                    _headers['Content-Type'] = headers['Content-Type'];
                }
                _headers = {..._headers, headers};
            }


            let options = {
                method: method,
                body: data !== null ? JSON.stringify(data) : null,
                cors: true,
                headers: _headers
            };


            let good_codes = [200, 201];
            if (url[0] === '/') {
                url = url.substr(1, url.length - 1);
            }

            fetch(`${this.host}/${url}`, options)
                .then(async (res) => {
                    if(good_codes.indexOf(res.status) + 1 === 0) {
                        try {
                            let jsonError = await res.json(res);
                            reject({status: res.status, statusText: res.statusText, answer: jsonError});
                        } catch (e) {
                            reject({status: res.status, statusText: res.statusText});
                        }
                    } else {
                        return res.json(res)
                    }

                })
                .then(json => resolve(json))
                .catch(err => reject(err));
        });
    }
}

export const OAuthFetcher = new RTFetcher(Config.OAUTH_API);
export const Fetcher = new RTFetcher(Config.API);


//
// export default function(url, method, data, headers) {
//     return new Promise((resolve, reject) => {
//         let _headers = {
//             'Content-Type': 'application/json'
//         };
//
//         if (AppStore.get('token')) {
//             _headers['Authorization'] = AppStore.get('token');
//         }
//
//         if (headers) {
//             if (headers['Content-Type']){
//                 _headers['Content-Type'] = headers['Content-Type'];
//             }
//             _headers = {..._headers, headers};
//         }
//
//
//         let options = {
//             method: method,
//             body: JSON.stringify(data),
//             cors: true,
//             headers: _headers
//         };
//
//
//         let good_codes = [200, 201];
//
//         fetch(`${Config.API}/${url}`, options)
//             .then((res) => {
//                 if(good_codes.indexOf(res.status) + 1 === 0) {
//                     reject({status: res.status, statusText: res.statusText});
//                 } else {
//                     return res.json(res)
//                 }
//
//             })
//             .then(json => resolve(json))
//             .catch(err => reject(err));
//     });
// }



// WEBPACK FOOTER //
// ./src/utils/fetch/index.js